import React, { useState, useEffect, useRef } from "react";
import { CardContent, Card, Grid, Button, Toolbar, Tooltip } from "@material-ui/core";
import KisshtTable from "components/table/KisshtTable";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import Colors from "shared/color";
import Header from "components/navigation/Header";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import link from "../../assets/svg/link.svg";
import objection from "../../assets/svg/objection.svg";
import CheckCircleIcon from "../../assets/svg/CheckCircleIcon.svg";
import CancelIcon from "../../assets/svg/CancelIcon.svg";
import PermissionButton from "components/ui/form/PermissionButton";
import CommonRemarksModal from "./dialog/CommonRemarksModal";
import { PERMISSIONS, ROUTE_NAME, ROUTES_VAR } from "shared/constants";
import KisshtLink from "components/ui/KisshtLink";

import {
  addObjection,
  fetchMobileNumberRequestList,
  requestReject,
  resolveObjection,
  sendLink,
} from "shared/api/MobileNumberRequest";
import { toast } from "react-toastify";
import CustomSelect from "components/custom/CustomSelect";
import CustomInput from "components/custom/CustomInput";
import { filterValidation, MerchantURl } from "shared/utils";
import "./MobileNumberRequest.scss";

const SEND_LINK_STATUS = [
  "INITIATED",
  "LINK_SENT",
  "OTP_SENT",
  "OTP_VERIFIED",
  "KYC_PENDING",
  "KYC_VERIFIED",
];

const OBJECTION_STATUS = ["COOLING"];

const RESOLVED_STATUS = ["ON_HOLD"];

const REJECT_STATUS = [
  "INITIATED",
  "LINK_SENT",
  "OTP_SENT",
  "OTP_VERIFIED",
  "KYC_PENDING",
  "KYC_VERIFIED",
  "COOLING",
  "ON_HOLD",
];

const UserReferenceCell = ({ value }) => {
  if (!value) return null;

  return <KisshtLink to={`${ROUTES_VAR.users}/${value}`}>{value}</KisshtLink>;
};

const KycStatusCell = ({ value }) => {
  if (!value) return null;

  return (
    <BootstrapBadge
      text={value.replace(/_/g, " ")}
      className={`kycBadge ${value.toLowerCase().replace(/_/g, "-")}`}
    />
  );
};

const CoolingPeriodCell = ({ value }) => (
  <p>
    <BootstrapBadge text={value} value={value} />
  </p>
);

const StatusBadgeCell = ({ value }) => (
  <span className={`statusBadge ${value?.toLowerCase().replaceAll(" ", "-")}`}>
    {value}
  </span>
);

const MobileNumberRequestActionCell = ({
  cell,
  onSendLink,
  onAddObjection,
  onResolveObjection,
  onReject,
  onSetModalData,
}) => {
  const status = cell.original.status;

  return (
    <Grid container>
      {SEND_LINK_STATUS.includes(status) && (
        <Grid item xs={2}>
          <Tooltip title="Send Link" arrow>
            <span>
              <PermissionButton
                style={{ border: "none" }}
                size="small"
                variant="outlined"
                startIcon={
                  <img
                    src={link}
                    alt="link"
                    style={{ width: "18px", height: "18px" }}
                  />
                }
                onClick={() => onSendLink(cell)}
                route={ROUTE_NAME.user}
                permission={PERMISSIONS.user.change_mobile_number}
                disabled={cell?.original?.link_resend_count >= 5}
                className="permissionButton"
              ></PermissionButton>
            </span>
          </Tooltip>
        </Grid>
      )}
      {OBJECTION_STATUS.includes(status) && (
        <Grid item xs={2}>
          <Tooltip title="Objection Raised" arrow>
            <span>
              <PermissionButton
                style={{ border: "none" }}
                size="small"
                variant="outlined"
                startIcon={
                  <img
                    src={objection}
                    alt="objection"
                    style={{ width: "18px", height: "18px" }}
                  />
                }
                onClick={() =>
                  onSetModalData({
                    open: true,
                    title: "Objection Raised",
                    type: "objectionRaised",
                    submitHandler: onAddObjection,
                    rowData: cell,
                  })
                }
                route={ROUTE_NAME.user}
                permission={PERMISSIONS.user.change_mobile_number}
                className="permissionButton"
              ></PermissionButton>
            </span>
          </Tooltip>
        </Grid>
      )}
      {RESOLVED_STATUS.includes(status) && (
        <Grid item xs={2}>
          <Tooltip title="Objection Resolved" arrow>
            <span>
              <PermissionButton
                style={{ border: "none" }}
                size="small"
                variant="outlined"
                startIcon={
                  <img
                    src={CheckCircleIcon}
                    alt="check"
                    style={{ width: "18px", height: "18px" }}
                  />
                }
                onClick={() =>
                  onSetModalData({
                    open: true,
                    title: "Objection Resolved",
                    type: "objectionResolved",
                    submitHandler: onResolveObjection,
                    rowData: cell,
                  })
                }
                route={ROUTE_NAME.user}
                permission={PERMISSIONS.user.change_mobile_number}
                className="permissionButton"
              ></PermissionButton>
            </span>
          </Tooltip>
        </Grid>
      )}
      {REJECT_STATUS.includes(status) && (
        <Grid item xs={3}>
          <Tooltip title="Rejection" arrow>
            <span>
              <PermissionButton
                style={{ border: "none" }}
                size="small"
                variant="outlined"
                startIcon={
                  <img
                    src={CancelIcon}
                    alt="cancel"
                    style={{ width: "18px", height: "18px" }}
                  />
                }
                onClick={() =>
                  onSetModalData({
                    open: true,
                    title: "Rejection",
                    type: "rejection",
                    submitHandler: onReject,
                    rowData: cell,
                  })
                }
                route={ROUTE_NAME.user}
                permission={PERMISSIONS.user.change_mobile_number}
                className="permissionButton"
              ></PermissionButton>
            </span>
          </Tooltip>
        </Grid>
      )}
    </Grid>
  );
};

export const MobileNumberRequest = (props) => {
  const { params, delteQueryParams } = props;
  let userDetails = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : "";

  const [spinning, setSpinning] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [usersData, setUsersData] = useState([]);
  const [usersDataCount, setUsersDataCount] = useState();

  const [merchantName, setMerchantName] = useState("");
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState(params["search"] || "");
  const [selected, setSelected] = useState(params["selected"] || "");
  const [reload, setReload] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // HIGH-01: page offset and merchant domain stay on this instance, not at module scope.
  const offsetRef = useRef(1);
  const merchantDomainRef = useRef("");

  const shouldShowActionColumn = usersData?.some(
    (item) => !["REJECTED", "COMPLETED", "EXPIRED"].includes(item?.status),
  );

  const SendLinkAPI = async (cell) => {
      if (spinning) return;

    const mobileChangeRequestRefNo =
      cell?.original?.mob_cha_req_reference_number;
    const payload = {
      mob_cha_req_reference_number: mobileChangeRequestRefNo,
    };
    setSpinning(true);

    try {
      const res = await sendLink(payload);
      toast.success(res?.message);
    } catch (error) {
      // eslint-disable-next-line
    }
    finally {
    setSpinning(false);
  }
  };

  const handleAddObjection = async (values, cell) => {
    const response = await addObjection({
      mob_cha_req_reference_number:
        cell?.original?.mob_cha_req_reference_number,
      remarks: values?.remark,
    });
    return response;
  };
  const handleResolveObjection = async (values, cell) => {
    const response = await resolveObjection({
      mob_cha_req_reference_number:
        cell?.original?.mob_cha_req_reference_number,
      request_created_by_subuser_ref_num: userDetails?.subuser_reference_number,
      remarks: values?.remark,
    });
    return response;
  };

  const handleRequestReject = async (values, cell) => {
    const response = await requestReject({
      mob_cha_req_reference_number:
        cell?.original?.mob_cha_req_reference_number,
      remarks: values?.remark,
    });
    return response;
  };

  const handleRemarksSubmit = async (values) => {
    setSpinning(true);
    try {
      const response = await modalData?.submitHandler(
        values,
        modalData?.rowData,
      );

      if (response?.success) {
        toast.success(response?.message || "Success");
        setModalData(null);
        await mobileNumberRequest();
      } else {
        toast.error(response?.message || "Something went wrong");
      }
    } catch (error) {
       // eslint-disable-next-line
    }
    finally {
    setSpinning(false);
  }
  };

  const actionColumn = {
    Header: "Action",
    accessor: "action",
    sortable: false,
    filterable: false,
    headerClassName: "user_action_column",
    Cell: (cell) => (
      <MobileNumberRequestActionCell
        cell={cell}
        onSendLink={SendLinkAPI}
        onAddObjection={handleAddObjection}
        onResolveObjection={handleResolveObjection}
        onReject={handleRequestReject}
        onSetModalData={setModalData}
      />
    ),
  };

  const columns = [
    {
      Header: "Requesting User Reference No",
      accessor: "requesting_user_reference_number",
      sortable: false,
      filterable: false,
      headerClassName: "common_small_tablewidth",
          Cell: (cell) => <UserReferenceCell value={cell.value} />,
    },
    {
      Header: "Existing User Reference No",
      accessor: "existing_user_reference_number",
      sortable: false,
      filterable: false,
      headerClassName: "common_small_tablewidth",
          Cell: (cell) => <UserReferenceCell value={cell.value} />,
    },
    {
      Header: "Requesting User Mobile Number",
      accessor: "requesting_mobile_number",
      sortable: false,
      filterable: false,
      headerClassName: "common_small_tablewidth",
    },
    {
      Header: "New Requested Mobile Number",
      accessor: "existing_mobile_number",
      sortable: false,
      filterable: false,
      headerClassName: "common_small_tablewidth",
    },
    {
      Header: "KYC Status",
      accessor: "kyc_status",
      sortable: false,
      filterable: false,
      Cell: (cell) => <KycStatusCell value={cell.value} />,
    },
    {
      Header: "Cooling Period Required",
      accessor: "cooling_off_required",
      sortable: false,
      filterable: false,
      Cell: (cell) => <CoolingPeriodCell value={cell.value} />,
    },
    {
      Header: "Status",
      accessor: "status",
      sortable: false,
      filterable: false,
      Cell: (cell) => <StatusBadgeCell value={cell.value} />,
    },
    ...(shouldShowActionColumn ? [actionColumn] : []),
  ];

  const getMerchantName = (merchantValue, merchant) => {
    if (merchantValue === "all" || merchantValue === "rufilo") {
      return "";
    } else if (merchantValue) {
      return merchantValue;
    }
    return merchant;
  };

  // HIGH-01: reset to page 1 before the request so a return visit does not reuse the old offset.
  useEffect(() => {
    merchantDomainRef.current = MerchantURl();
    offsetRef.current = 1;
    setMerchantName(merchantDomainRef.current);
    mobileNumberRequest();
  }, [reload]);

  const mobileNumberRequest = async () => {
    let data = {
      limit: 20,
      offset: offsetRef.current,
      status: status,
      merchant_name: getMerchantName(merchantName, merchantDomainRef.current),
    };
    setSpinning(true);
      try {
        const response = await fetchMobileNumberRequestList(
        selected,
        search,
        data,
        );
        if (response.hasOwnProperty("success") && response.success) {
          const { data } = response;
          setUsersData(data?.mobile_number_change_requests);
          setUsersDataCount(data?.total);
        }
      } catch (error) {
        // eslint-disable-next-line
      }
      finally
      {
        setSpinning(false);
      }
    };

  const onPageChange = (value) => {
    offsetRef.current = value;
    mobileNumberRequest();
  };

  const handleMerchantName = async (e) => {
    e.persist();
    if (e) {
      let item = e.target.value;
      if (!item) {
        setMerchantName("");
        await delteQueryParams();
      } else {
        setMerchantName(item);
      }
    }
  };

  const handleStatus = async (e) => {
    e.persist();
    if (e) {
      let item = e.target.value;
      if (!item) {
        setStatus("");
        setSearch("");
        await delteQueryParams();
      } else {
        setStatus(item);
      }
    }
  };

  const handleSelect = async (e) => {
    e.persist();
    if (e) {
      let item = e.target.value;
      if (!item) {
        setSearch("");
        setErrorMessage("");
        await delteQueryParams();
        setReload(!reload);
      }
      setSelected(item);
      setSearch("");
    }
  };

  const OnHandleSearch = (e) => {
    const validation_msg = filterValidation(selected, e.target.value);
    setSearch(e.target.value);
    setErrorMessage(validation_msg);
  };

  const handleSearch = async (e) => {
  e.preventDefault();
  if (!selected.length && !search.length && !status && !merchantName) return;
    offsetRef.current = 1;
  mobileNumberRequest();
};
  const refreshHandler = async (_) => {
    setSearch("");
    setSelected("");
    setStatus("");
    setMerchantName("");
    await delteQueryParams();
    offsetRef.current = 1;
    setReload(!reload);
  };

  return (
    <>
      <Header open={props.open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader />
        </Toolbar>
        <Toolbar>
          <Grid
            container
            alignItems="center"
            className="crum_padding extra_padding"
          >
            <Grid item xs={12}>
              <Grid item xs={4}>
                <BreadcrumbsHeader text="Mobile Number Change Request List" />
              </Grid>
            </Grid>
            <Grid item xs={12} className="crum_innerPadding">
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <CustomSelect
                    onChange={handleMerchantName}
                    value={merchantName}
                    multiple={false}
                    nulloption="Select merchant"
                    options={{
                      all: "All",
                      tradofina: "Tradofina",
                      plebgraph: "Plebgraph",
                    }}
                    className="common_global_filter"
                  />
                </Grid>
                <Grid item>
                  <CustomSelect
                    nulloption="Select Status"
                    onChange={(e) => handleStatus(e)}
                    value={status}
                    options={{
                      INITIATED: "INITIATED",
                      LINK_SENT: "LINK_SENT",
                      OTP_SENT: "OTP_SENT",
                      OTP_VERIFIED: "OTP_VERIFIED",
                      KYC_PENDING: "KYC_PENDING",
                      KYC_VERIFIED: "KYC_VERIFIED",
                      COOLING: "COOLING",
                      ON_HOLD: "ON_HOLD",
                      REJECTED: "REJECTED",
                      COMPLETED: "COMPLETED",
                      EXPIRED: "EXPIRED",
                    }}
                    className="common_global_filter"
                  />
                </Grid>
                <Grid item>
                  <CustomSelect
                    onChange={handleSelect}
                    nulloption="select"
                    value={selected}
                    options={{
                      user_reference_number: "User Reference Number",
                      mobile_number: "Mobile Number",
                    }}
                    className="common_global_filter"
                  />
                </Grid>
                <Grid item>
                  <Grid>
                    <CustomInput
                      placeholder="Search"
                      onChange={(e) => OnHandleSearch(e)}
                      value={search}
                      className="common_custom_input"
                    />
                  </Grid>
                  <Grid>
                    {search ? (
                      <span
                        style={{
                          color: "red",
                          fontSize: "13px",
                          position: "absolute",
                        }}
                      >
                        {errorMessage}
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    className="shadow-none common_kissht_btn"
                    color="primary"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item>
                  <Button onClick={refreshHandler} size="small" color="primary">
                    Reset
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </Header>
      <div className="common_padding_from_title_withLessFilter">
        <Card
          style={{
            boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}`,
          }}
        >
          <CardContent style={{ height: "50px" }}></CardContent>
          <CardContent className="table_card_mobile">
            <KisshtTable
              loading={spinning}
              columns={columns}
              data={usersData}
              onPageChange={onPageChange}
              showPagination={usersData.length > 0}
              offset={offsetRef.current}
              totalCount={usersDataCount}
            />
          </CardContent>
        </Card>
      </div>

      {modalData?.open ? (
        <CommonRemarksModal
          visible={modalData?.open}
          title={modalData?.title}
          type={modalData?.type}
          handleClose={() => setModalData(null)}
          handleSubmit={handleRemarksSubmit}
        />
      ) : null}
    </>
  );
};
